import React from 'react';

/**
 * Sticky toast for in-app alerts (reminders, etc.).
 */
export default function ToastStack({ toasts, onDismiss }) {
  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed', top: '16px', right: '16px', zIndex: 9999,
      display: 'flex', flexDirection: 'column', gap: '10px',
      maxWidth: 'min(360px, calc(100vw - 32px))',
    }}>
      {toasts.map(t => (
        <div
          key={t.id}
          role="alert"
          style={{
            background: '#fff',
            border: '1px solid #FCD34D',
            borderLeft: '4px solid #F59E0B',
            borderRadius: '12px',
            padding: '14px 16px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
            <div>
              <p style={{ fontWeight: 700, fontSize: '14px', marginBottom: '4px' }}>
                {t.title || 'Reminder'}
              </p>
              <p style={{ fontSize: '13px', color: '#4B5563', lineHeight: 1.45 }}>{t.message}</p>
            </div>
            <button
              type="button"
              onClick={() => onDismiss(t.id)}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: '18px', lineHeight: 1, color: '#9CA3AF', flexShrink: 0,
              }}
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
